<sk-restore-history
    [jobs]="restoreJobs"
    [isRefreshing]="isRefreshing"
    (refreshEvent)="loadRestoreJobs(true)"
    (dateEvent)="loadRestoreJobsDateRange($event.start, $event.end)">
</sk-restore-history>